// 📄 storageService.ts
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from '../firebase';

export interface UploadedAttachment {
  name: string;
  url: string;
  contentType: string;
  size: number;
}

/**
 * Sube un archivo a Firebase Storage bajo `path` (ej. "known_errors/{errorId}")
 * y devuelve la URL de descarga. Genérico para que cualquier módulo lo reutilice.
 */
export const uploadAttachment = async (path: string, file: File): Promise<UploadedAttachment> => {
  const safeName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
  const storageRef = ref(storage, `${path}/${Date.now()}_${safeName}`);
  await uploadBytes(storageRef, file);
  const url = await getDownloadURL(storageRef);

  return {
    name: file.name,
    url,
    contentType: file.type || 'application/octet-stream',
    size: file.size
  };
};

export const uploadAttachments = async (path: string, files: File[]): Promise<UploadedAttachment[]> => {
  return Promise.all(files.map(file => uploadAttachment(path, file)));
};
